import protectedAxios from '../auth/axios.js';

export const pripadActionsMixin = {
  data() {
    return {
      warningMessage: {
        new_id: '',
        open: false,
        header: '',
        title: '',
        text: '',
        action: () => {},
      },
    };
  },
  methods: {
    openCancelWarning(new_id) {
      this.warningMessage.new_id = new_id;
      this.warningMessage.open = true;
    },
    cancelPripad() {
      protectedAxios
        .post(`pripady/${this.warningMessage.new_id}/cancel`)
        .then(() => {
          this.reloadData();
        })
        .catch(e => {
          console.error(e);
        });
    },
  },
};
